import { container_classname } from "@components/new-ui/constants";
import CTAButtons from "@components/new-ui/CTAButtons";
import Image from "next/image";

export interface CTASectionProps {
    content: string;
    imageUrl: string;
    imgAlt: string;
    btnText: string;
}

const defaultCTAContent: CTASectionProps = {
    content: "Grow your business on WhatsApp with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/alternatives/interakt/wa-gallabox.png",
    imgAlt: "wa-gallabox",
    btnText: "Try for free",
};

export const AlternativesCTASection: React.FC<{ ctaContent?: CTASectionProps }> = ({ ctaContent = defaultCTAContent }) => {
    const { content, imageUrl, imgAlt, btnText } = ctaContent;

    return (
        <section
            className={`${container_classname} flex md:flex-row flex-col rounded-md md:items-center py-10 md:py-6 my-20`}
            style={{
                background: "linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%)",
            }}
        >
            <div className="mt-4">
                <Image width={300} height={300} src={imageUrl} alt={imgAlt} />
            </div>

            <div className="md:px-16">
                <p className="text-5xl font-semibold text-white pb-10" style={{ fontFamily: "Degular Display" }}>
                    {content}
                </p>
                <CTAButtons primaryButtonText={btnText} variant="secondary-light" />
            </div>
        </section>
    );
};
